import { createContext } from 'react';

export type ChannelWithoutProgram = Omit<RiksTV.ClientAPI.Channel, 'programs'>;

export const TvGuideContext = createContext<{ channels: ChannelWithoutProgram[]; selectedDate: Date }>({
  channels: [],
  selectedDate: new Date(),
});
